module.exports = __webpack_public_path__ + "41ed4edc8451019d8c9150c0d5673d14.pdf";